import NextImage, { ImageProps } from "next/image";

type IImageProps = ImageProps & {
  src: string;
  srcSet?: string;
};

const Image = (props: IImageProps) => {
  const { src, className, width, height, srcSet, ...rest } = props;

  if (!src) {
    return null;
  }

  const urlPrefix = process.env.NEXT_PUBLIC_ASSET_PREFIX || "";
  let processedSrc = src;

  if (urlPrefix) {
    if (
      src.startsWith("http://") ||
      src.startsWith("https://") ||
      src.startsWith("data:") ||
      src.startsWith("blob:") ||
      src.startsWith("//") ||
      src.startsWith(urlPrefix)
    ) {
      processedSrc = src;
    } else if (src.startsWith("./")) {
      processedSrc = `${urlPrefix}${src.substring(1)}`;
    } else if (src.startsWith("/")) {
      processedSrc = `${urlPrefix}${src}`;
    } else {
      processedSrc = `${urlPrefix}/${src}`;
    }
  }

  if (srcSet) {
    return (
      <img
        src={processedSrc}
        className={className}
        width={width}
        height={height}
        srcSet={srcSet}
        {...rest}
      />
    );
  }

  return (
    <NextImage
      src={processedSrc}
      className={className}
      width={width ?? 0}
      height={height ?? 0}
      {...rest}
    />
  );
};

export default Image;
